import React from "react";
import { Link, useLocation } from "react-router-dom";
import { dashboardColors, theme } from "../../themes/Theme";
import ManageEventsItems from "./ManageEventSidebarNav";

const ManageEventSidebar = () => {
    const location = useLocation();

    const isActive = (item) => {
        if (!item.matchPaths) return false;
        return item.matchPaths.some((p) => {
            const regex = new RegExp("^" + p.replace(":profileId", "[^/]+"));
            return regex.test(location.pathname);
        });
    };

    return (
        <nav className="manage-event-sidebar-nav">
            {ManageEventsItems.map(item => (
                <Link
                    key={item?.path}
                    to={item?.path}
                    className={`manage-event-sidebar-link${isActive(item) ? " active" : ""}`}
                >
                    <img src={item?.icon} alt={item?.label} className="manage-event-sidebar-icon" />
                    <span className="manage-event-sidebar-label">{item?.label}</span>
                </Link>
            ))}

            <style>{`
                .manage-event-sidebar-nav {
                    width: 100%;
                    min-width: 70px;
                    background: #fff;
                    padding: 0;
                }
                .manage-event-sidebar-link {
                    text-decoration: none;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 70px;
                    width: 100%;
                    background: #fff;
                    color:${dashboardColors[theme].primaryTextColor};
                    border: none;
                    padding: 50px 0px;
                    font-weight: 500;
                    font-size: 14px;
                    transition: background 0.2s;
                    cursor: pointer;
                }
                .manage-event-sidebar-link.active {
                    background: #e6f0fa;
                }
                .manage-event-sidebar-icon {
                    width: 28px;
                    height: 28px;
                    margin-bottom: 4px;
                }
                .manage-event-sidebar-label {
                    font-size: 14px;
                    font-weight: 500;
                    color:${dashboardColors[theme].primaryTextColor};
                    margin-top: 0;
                    letter-spacing: 0;
                    text-align: center;
                    word-break: break-word;
                    white-space: normal;
                    max-width: 60px;
                    line-height: 1.1;
                }
                .manage-event-sidebar-link:hover {
                    text-decoration: none;
                }
            `}</style>
        </nav>
    );
};

export default ManageEventSidebar;
